contentTypeNode